import _ from 'underscore';

import { isBillingLinkPermission as isBillingLinkPermissionFunc } from '@bingads-webui/multi-agency-utils';

import { ScopeLevel, IScope } from '../types/notification.types';

export * from './i18n-map';

export * from './filters';

export const supportLegacyI18n = (i18n: any, i18nMap: any) => ({
  getString: (key: string, options?: Object) => {
    const value: string = (i18nMap as any)[key];
    return i18n.getString(value, options);
  },
  getLocale: () => i18n.getLocale(),
});

export function shouldRender(level: ScopeLevel, changeLevel: ScopeLevel): boolean {
  return changeLevel >= level;
}

export function shouldClear(level: ScopeLevel, changeLevel: ScopeLevel): boolean {
  return changeLevel >= level;
}

export function isAvailable(currentScope: IScope, availableScopes: ScopeLevel[] = []) {
  const { aid } = currentScope.values;
  const isCustomerScope = !aid;

  if (!_.isEmpty(availableScopes)
    && !_.contains(availableScopes, ScopeLevel.customer)
    && isCustomerScope) {
    return false;
  }
  return true;
}

export const generateUNQViewAllLink = (userContext: any, scopeValues: any) => () => {
  // verify aid existing in scope to confirm it's really in Account level
  const preFilter = scopeValues.aid && userContext.CurrentAccount && userContext.CurrentAccount.AccountNumber ? JSON.stringify([{
    Field: 'AccountNumber',
    Operator: 2,
    Values: userContext.CurrentAccount.AccountNumber,
  }]) : 'all';

  return {
    siteMapId: 'notifications',
    search: `?cid=${userContext.CurrentCustomer.Id}&uid=${userContext.CurrentUser.Id}&filter=${preFilter}`,
  };
};

export function calcScopeLevel(scope: IScope) {
  let scopeLevel = ScopeLevel.root;
  if (_.isNumber(scope.values.cid) || _.isString(scope.values.cid)) scopeLevel = ScopeLevel.customer;
  if (_.isNumber(scope.values.aid) || _.isString(scope.values.aid)) scopeLevel = ScopeLevel.account;
  if (_.isNumber(scope.values.campaignId) || _.isString(scope.values.campaignId)) scopeLevel = ScopeLevel.campaign;
  if (_.isNumber(scope.values.adGroupId) || _.isString(scope.values.adGroupId)) scopeLevel = ScopeLevel.adGroup;
  return scopeLevel;
}

export const SmartCampaignPathPrefix = '/campaign/smart';

export function isSmartCampaignPath(path: string): boolean {
  return _.isString(path) && path.toLowerCase().indexOf(SmartCampaignPathPrefix) === 0;
}

// Currently, CMUI ui-next and CCUI are using the shared site map, while
// Smart Campaign uses its own router. If the navigation is
//   - from Smart to others; or
//   - from others to Smart
// we need to manual add location.origin to the relative path.
// We could update the condition here if we have more "external" sites.
export function shouldNavigateCrossSite(path: string, currentPath: string) : boolean {
  return isSmartCampaignPath(path) !== isSmartCampaignPath(currentPath);
}

// This function is used for checking whether agency is visiting billing-only linked account, in
// this case, billing-unrelated notifications should be hidden.
export const isBillingLinkPermission = (settingsContext: any) => isBillingLinkPermissionFunc(settingsContext);
